import script from "./GameInfoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameInfoView.vue?vue&type=script&setup=true&lang=ts"

import "./GameInfoView.vue?vue&type=style&index=0&id=3cfd1078&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cfd1078"]])

export default __exports__